import SVG from "@Components/Icons/SVG";
export default class Basic extends SVG {
    path = [
        "M 28 20 C 26 20 24 22 24 24 V 52 V 81 C 24 83 26 85 28 85 H 72 C 75 84 76 82 76 81 H 76 V 24 C 75 22 74 20 71 20 M 30 25 H 70 V 79 H 61 V 67 C 61 65 59 63 57 63 H 42 C 40 63 39 65 39 67 V 79 H 30 V 25 M 56 79 H 44 V 68 H 56 V 79 M 44 54 H 55 C 56 54 58 54 58 52 C 58 50 56 50 55 50 H 44 C 43 50 41 50 41 52 C 41 54 43 54 44 54 M 44 40 H 55 C 56 40 58 40 58 38 C 58 36 56 36 55 36 H 44 C 43 36 41 36 41 38 C 41 40 43 40 44 40",
    ];
    evenOdd = true;
}
